module.exports = __webpack_public_path__ + "static/media/smart.8ea71135.png";